import React, { Component } from "react";

export class ProductAttribute {
    key: string = '';
    value: string = '';
}

class AttributesProps {
    attributes: ProductAttribute[] = [];
}

class AttributesState { }

class Attributes extends Component<AttributesProps, AttributesState> {

    render() {
        if (!this.props.attributes?.length) {
            return <></>;
        }

        const attributeSplit = Math.ceil(this.props.attributes?.length / 2);
        const lhsAttributes = this.props.attributes?.slice(0, attributeSplit);
        const rhsAttributes = this.props.attributes?.slice(attributeSplit);

        return (
            <div>
                <div className="columns">
                    <div className="column">
                        <h3 className="product-group is-size-5 has-text-weight-bold">Specifications</h3>
                    </div>
                </div>

                <div className="columns product-attributes">
                    <div className="column">
                        {lhsAttributes.map(attribute => {
                            return (
                                <div key={attribute.key} className="product-attribute">
                                    <span className="product-attribute-key">
                                        {attribute.key}:
                                    </span>
                                    <span className="product-attribute-value">
                                        {attribute.value}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                    <div className="column">
                        {rhsAttributes.map(attribute => {
                            return (
                                <div key={attribute.key} className="product-attribute">
                                    <span className="product-attribute-key">
                                        {attribute.key}:
                                    </span>
                                    <span className="product-attribute-value">
                                        {attribute.value}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Attributes;
